import { render } from "./RevisionStateSelector.vue?vue&type=template&id=5151fa4b"
import script from "./RevisionStateSelector.vue?vue&type=script&lang=js"
export * from "./RevisionStateSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__